import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const NewLotPaymentTitleColumns = ({ fromTransactionPage }) => (
    <>
        <GridTable.Data>
            <I18n component="span" id="transfer.coelsa.id" className="align-center" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.destinationCbu" className="align-center" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.accountType" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.cuit" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.amount" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.vaucher" />
        </GridTable.Data>
        <GridTable.Data>
            <I18n component="span" id="lotPayment.new.motivate" />
        </GridTable.Data>
        {fromTransactionPage && (
            <GridTable.Data>
                <I18n component="span" id="lotPayment.new.state" />
            </GridTable.Data>
        )}
    </>
);

export default NewLotPaymentTitleColumns;
